/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestCasesRouteImport } from './routes/test-cases'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TestCasesIdRouteImport } from './routes/test-cases_.$id'
import { Route as InvocationsIdRouteImport } from './routes/invocations.$id'

const TestCasesRoute = TestCasesRouteImport.update({
  id: '/test-cases',
  path: '/test-cases',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestCasesIdRoute = TestCasesIdRouteImport.update({
  id: '/test-cases_/$id',
  path: '/test-cases/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvocationsIdRoute = InvocationsIdRouteImport.update({
  id: '/invocations/$id',
  path: '/invocations/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/test-cases': typeof TestCasesRoute
  '/invocations/$id': typeof InvocationsIdRoute
  '/test-cases/$id': typeof TestCasesIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/test-cases': typeof TestCasesRoute
  '/invocations/$id': typeof InvocationsIdRoute
  '/test-cases/$id': typeof TestCasesIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/test-cases': typeof TestCasesRoute
  '/invocations/$id': typeof InvocationsIdRoute
  '/test-cases_/$id': typeof TestCasesIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/test-cases' | '/invocations/$id' | '/test-cases/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/test-cases' | '/invocations/$id' | '/test-cases/$id'
  id: '__root__' | '/' | '/test-cases' | '/invocations/$id' | '/test-cases_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TestCasesRoute: typeof TestCasesRoute
  InvocationsIdRoute: typeof InvocationsIdRoute
  TestCasesIdRoute: typeof TestCasesIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test-cases': {
      id: '/test-cases'
      path: '/test-cases'
      fullPath: '/test-cases'
      preLoaderRoute: typeof TestCasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-cases_/$id': {
      id: '/test-cases_/$id'
      path: '/test-cases/$id'
      fullPath: '/test-cases/$id'
      preLoaderRoute: typeof TestCasesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invocations/$id': {
      id: '/invocations/$id'
      path: '/invocations/$id'
      fullPath: '/invocations/$id'
      preLoaderRoute: typeof InvocationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TestCasesRoute: TestCasesRoute,
  InvocationsIdRoute: InvocationsIdRoute,
  TestCasesIdRoute: TestCasesIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
